module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5V7D8"))).then(() => module.bundle.root('aVi2q'));